module.exports = __webpack_public_path__ + "static/media/comment-add-svgrepo-com.7aa03898.svg";